import React from 'react';
import PropTypes from 'prop-types';
import { Link, Stack, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DialogDefaultV2 from '../DialogDefaultV2';
import GeoPointMap from '../GeoPointMap';

const LocationDetail = ({ label, value }) => (
  <Typography variant="caption" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
    {label}: {value}
  </Typography>
);

LocationDetail.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const ArquivoGeoMapDialogV2 = ({
  open,
  onClose,
  point,
  title,
  mapsUrl,
  coords,
  precisao,
  zIndex,
}) => (
  <DialogDefaultV2
    open={open}
    handlerCancel={onClose}
    title={title || 'Local da foto'}
    maxWidth="md"
    fullWidth
    readOnly
    zIndex={zIndex}
  >
    {open && point ? (
      <Stack spacing={1.5}>
        <GeoPointMap
          points={[point]}
          active={open}
          height={420}
        />
        {point.endereco ? (
          <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
            {point.endereco}
          </Typography>
        ) : null}
        {coords ? <LocationDetail label="Lat/Long" value={coords} /> : null}
        {precisao ? <LocationDetail label="Precisão" value={precisao} /> : null}
        {mapsUrl ? (
          <Link
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            underline="hover"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              fontWeight: 500,
              alignSelf: 'flex-start',
            }}
          >
            <OpenInNewIcon sx={{ fontSize: 16 }} />
            Abrir no Google Maps
          </Link>
        ) : null}
      </Stack>
    ) : null}
  </DialogDefaultV2>
);

ArquivoGeoMapDialogV2.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  point: PropTypes.shape({
    id: PropTypes.string.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    endereco: PropTypes.string,
  }),
  title: PropTypes.string,
  mapsUrl: PropTypes.string,
  coords: PropTypes.string,
  precisao: PropTypes.string,
  zIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
};

ArquivoGeoMapDialogV2.defaultProps = {
  point: null,
  title: 'Local da foto',
  mapsUrl: null,
  coords: null,
  precisao: null,
  zIndex: null,
};

export default ArquivoGeoMapDialogV2;
